let stripePromise = null;

export default {
  install(Vue, options) {
    if (!options || !options.publicKey) {
      console.error('Stripe plugin: Missing public key!');
      return;
    }

    if (!options.scriptSrc) {
      console.error('Stripe plugin: Missing script src!');
    }

    if (!stripePromise) {
      stripePromise = new Promise((resolve, reject) => {
        if (window.Stripe) {
          resolve(window.Stripe(options.publicKey));
          return;
        }

        const script = document.createElement('script');
        script.src = options.scriptSrc;
        script.onload = () => {
          resolve(window.Stripe(options.publicKey));
        };
        script.onerror = reject;
        document.head.appendChild(script);
      });
    }

    Vue.prototype.$getStripe = () => stripePromise;
  }
};